export enum TextWhiteSpace {
  Normal = 'normal',
  Nowrap = 'nowrap'
}
